// src/theme/typography.js
import { colors } from './colors';

export const typography = {
  fontFamily: '"Helvetica Neue", "Arial", sans-serif',
  h1: {
    fontSize: '2.5rem',
    fontWeight: 700,
    color: colors.primary.main,
  },
  h2: {
    fontSize: '2rem',
    fontWeight: 600,
    color: colors.primary.main,
  },
  h3: {
    fontSize: '1.75rem',
    fontWeight: 600,
    color: colors.primary.main,
  },
  h4: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: colors.primary.main,
  },
  h5: {
    fontSize: '1.25rem',
    fontWeight: 500,
    color: colors.primary.main,
  },
  h6: {
    fontSize: '1rem',
    fontWeight: 500,
    color: colors.primary.main,
  },
  body1: {
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '0.875rem',
    lineHeight: 1.43,
  },
};